import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-procurement-overview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './procurement-overview.html',
  styleUrls: ['./procurement-overview.css'],
})
export class ProcurementOverviewComponent {}
